export enum NylasSectionIdEnum {
  Overview = 'overview',
  ConnectYourAccounts = 'connect-your-accounts',
  ShareableIndividualLinks = 'shareable-individual-links',
  ShareableRoundRobinLinks = 'shareable-round-robin-links',
  Features = 'features',
  RoundRobinScheduler = 'round-robin-scheduler',
  YourScheduler = 'your-scheduler',
  Users = 'users',
}

export const SEARCH_PARAMS = {
  code: 'code',
  state: 'state',
  calendarConnectionFailed: 'calendarConnectionFailed',
}
